













import { Component, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import store from '@/store'
import { ExStore } from 'vuex'

@Component
export default class ManagePatient extends Vue {
  $store!: ExStore

  get storedCount() {
    return this.$store.getters['user/sessionData'](
      'labotestStoredCount'
    ) as number
  }

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (allow?: boolean) => void
  ) {
    if (from.name !== 'LabotestImportConfirm') {
      next(false)
      return
    }
    if (
      typeof store.getters['user/sessionData']('labotestStoredCount') !==
      'number'
    ) {
      next(false)
      return
    }
    next()
  }

  beforeRouteLeave(to: Route, from: Route, next: (allow?: boolean) => void) {
    this.$store.commit('user/setSessionData', { labotestStoredCount: null })
    next()
  }
}
